export const canvasStyleQuickInfo = {
  "t-shirts": {
    "Classic": "A customer-favorite everyday tee.",
    "Relaxed": "A roomier classic tee.",
    "Heavyweight": "A soft tee with a boxier fit and more weight.",
    "Extra-Soft": "A buttery soft, lightweight tee. Size up for a roomier fit!",
    "Premium": "Now 100% cotton and relaxed fit - gets softer with every wash!",
    "V-Neck": "A flattering t-shirt with a V-shaped neckline.",
    "Vintage": "A retro-style tee with a lived-in look & feel.",
    "Tall": "A classic t-shirt with a longer length.",
    "Active": "A lightweight, moisture-wicking tee for athletic performance.",
    "Dolman": "A wide-sleeve, super soft and lightweight tee.",
    "Boxy": "A boxy, 100% cotton tee that rests near the hip.",
    "Streetwear": "A relaxed heavyweight tee with a soft, lived-in feel."
  },
  "bags": {
    "Belt Bag": "Dimensions: 5H&quot; x 7.5&quot;W x 2.5&quot;D | Strap: Adjustable",
    "Crossbody Bag": "Dimensions: 8.3H&quot; x 13.4&quot;W x 4&quot;D | Strap: Adjustable"
  }
}
